/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { QuantityPlanBase } from "../../../../schema/generated/QuantityPlan";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class QuantityPlanDataApi extends EntityDataApi<QuantityPlanBase> {
  public readonly def = idbEntityDefs.QuantityPlan;
}